export default "__VITE_ASSET__f06db745__"